import "element-plus/dist/index.css";
import "./styles.css";

import ElementPlus from "element-plus";
import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "./App.vue";
import { router } from "./router";

const showBootstrapError = () => {
  const root = document.querySelector("#app");
  if (!root || root.hasChildNodes()) {
    return;
  }

  root.innerHTML =
    '<main style="max-width:36rem;margin:15vh auto;padding:2rem;font-family:system-ui,sans-serif;line-height:1.6"><h1>页面无法加载</h1><p>当前浏览器内核可能过旧，请切换 360 极速模式，或使用 Chrome / Edge 访问。</p></main>';
};

window.addEventListener("error", showBootstrapError, { once: true });
window.addEventListener("unhandledrejection", showBootstrapError, { once: true });

try {
  createApp(App).use(createPinia()).use(router).use(ElementPlus).mount("#app");
} catch {
  showBootstrapError();
}
